import React, { useEffect, useState } from "react";
import { Col, Form, Row, Modal } from "react-bootstrap";
import toast from "react-hot-toast";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import Navbar from "../../../Components/Navbar/Navbar";
import Table from "../../../Components/TableTemplate/Table";
import {
    numberFormat,
    refreshPage,
    toastStyle,
    getType,
    getTodayDateISO
} from "../../../Helpers/Utils/Common";
import { searchExpenses, updateExpenseStatus } from "../../../Helpers/apiCalls/Reports/DailyExpensesApi";
import { CSVLink } from "react-csv";
import downloadIcon from "../../../Assets/Images/download_icon.png";
import ViewModal from "../../../Components/Modals/ViewModal";
import Footer from "../../../Components/Footer/Footer";

export default function ViewDailyExpenses() {
    const { id, shop } = useParams();
    const { state } = useLocation();
    let navigate = useNavigate();
    const accountType = getType();
    const [inactive, setInactive] = useState(true);
    const [filterConfig, setFilterConfig] = useState({
        branch_id: id,
        by_branch: 0,
        date_from: state?.date_from,
        date_to: state?.date_to,
    })
    const [showLoader, setShowLoader] = useState(false);
    const [expenses, setExpenses] = useState([]);
    const [expensesItems, setExpensesItems] = useState([]);
    const [totalAmount, setTotalAmount] = useState("");
    const [branchName, setBranchName] = useState("");
    const [expenseDate, setExpenseDate] = useState("");
    const [selectedRow, setSelectedRow] = useState([]);
    const [selectedRowItem, setSelectedRowItem] = useState([]);
    // VIEW
    const [showViewBranchModal, setShowViewBranchModal] = useState(false);
    const handleCloseViewBranchModal = () => setShowViewBranchModal(false);

     /* delete modal handler */
     const [showReviewModal, setShowReviewModal] = useState(false);
     const handleShowReviewModal = () => setShowReviewModal(true);
     const handleCloseReviewModal = () => setShowReviewModal(false);

    const excelHeaders = [
        { label: "Item", key: "name" },
        { label: "Quantity", key: "qty" },
        { label: "Unit", key: "unit" },
        { label: "Unit Price", key: "price" },
        { label: "Amount", key: "total" },
        { label: "Status", key: "status" },
        { label: "Approved By", key: "approved_by_name" },
        { label: "Time Added", key: "added_on" },
        { label: "Store", key: "store" },
    ];

    // SEARCH USER
    function handleOnSearch(e) {
        const { name, value } = e.target;
        setFilterConfig((prev) => {
            return { ...prev, [name]: value };
        });
    }

    function ViewBtn(row) {
        return (
            <button
                name="action"
                className="btn btn-sm view-btn-table"
                id={row.id}
                onClick={() => handlePrint(row.id)}
            >
                View
            </button>
        );
    }

    function handlePrint(id) {
        navigate('/dailyexpenses/print/' + id,'_blank')
    }

    function handleSelectChange(e, row) {
        setSelectedRow(row);
        setSelectedRowItem(row.expense_item[0]);

        if (e.target.value === "review") {
            handleShowReviewModal()
        } else if (e.target.value === "edit") {
            navigate("/dailyexpenses/edit/" + row.id)
        }
    }
    
    
    function ActionBtn(row, type) {
        return (
            <Form.Select
                name="action"
                className="PO-select-action"
                onChange={(e) => handleSelectChange(e, row)}
            >
                <option value="" hidden selected>
                    Select
                </option>
                { accountType === "admin" ? (
                    <>
                        <option value="review" className="color-options">
                            Review
                        </option>
                        <option value="edit" className="color-options">
                            Edit
                        </option>
                    </>
                    ): null
                }
            </Form.Select>
        );
    }

    async function fetchData() {
        setShowLoader(true);
        setExpenses([])
        setExpensesItems([])
        var expenseItem = []

        const response = await searchExpenses(filterConfig);

        if (response.error) {
        } else {
            setBranchName(response.data.data[0].branch_name);
            setExpenseDate(response.data.data[0].expense_date)
            var expense = response.data.data.map((data) => {
                var info = data;
                info.grand_total = numberFormat(data.grand_total)
                return info;
            });
            response.data.data.map((data) => {
                data.expense_item.map((item) => {
                    var info = item;
                    info.store = expense[0].store_name;
                    info.qty = numberFormat(item.qty)
                    info.price = numberFormat(item.price)
                    info.total = numberFormat(item.total)
                    info.added_on = new Date(item.added_on).toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'})
                    info.approved_by_name = data.approved_by_name;
                    expenseItem.push(info)
                    // return info;
                });
            });
            setExpenses(expense)
            setExpensesItems(expenseItem)

            var total = response.data.total_expense? response.data.total_expense : "0";
            setTotalAmount(total);
        }
        setShowLoader(false);
    }
    

    async function handleChangeExpenseStatus(status) {
        const response = await updateExpenseStatus(selectedRow.id, status);
        
        if (response.error) {
            toast.error(response.error.response.data.messages.error, {
                style: toastStyle(),
            });
        } else {
            toast.success("Successfully Updated Cash Advance Status!", {
                style: toastStyle(),
            });
            setTimeout(() => {
                refreshPage()
            }, 1000);
        }
    }

    // React.useEffect(() => {
    //     fetchFranchisee();
    // }, []);

    useEffect(() => {
        fetchData();
    }, [filterConfig]);

    return (
        <div>
            <div className="page">
                <Navbar
                    onCollapse={(inactive) => {
                        setInactive(inactive);
                    }}
                    active={"DS REPORTS"}
                />
            </div>

            <div
                className={`manager-container ${
                    inactive ? "inactive" : "active"
                }`}
            >
                {/* headers */}
                <Row className="mb-3">
                    <Col xs={12} lg={10}>
                        <h1 className="page-title ps-2 ms-3 ms-md-0 ps-md-0 ms-md-0 fs-2"> {branchName} </h1>
                    </Col>
                    <Col xs={12} lg={2}>
                        <h1 className="page-title ps-2 ms-3 ms-md-0 ps-md-0 ms-md-0 fs-4"> TOTAL: {numberFormat(totalAmount)} </h1>
                    </Col>
                    <Col xs={12} lg={10}>
                        <h1 className="page-title ps-2 ms-3 ms-md-0 ps-md-0 ms-md-0 fs-6"> {new Date(expenseDate).toLocaleDateString( "en-us", { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })} </h1>
                    </Col>
                </Row>

                <div className="tab-content">
                    <div className="mb-3" />
                        <span className="ps-3 mb-2 align-middle d-none d-md-inline d-flex text-secondary">
                            Filter By:
                        </span>
                        <Row className="PO-filters flex flex-row mx-2 my-1">
                            <Col xs={12} lg={4} className="mb-2 mb-lg-0">
                            <Form.Select
                            name="status"
                            className="date-filter force-width w-full"
                            onChange={(e) => handleOnSearch(e)}
                            >
                                <option value="" selected disabled>
                                    Status
                                </option>
                                <option value="">All</option>
                                <option value="pending">Pending</option>
                                <option value="pproved">Approved</option>
                                <option value="disapproved">Disapproved</option>
                            </Form.Select>
                            </Col>
                        </Row>
                    <div className="mb-2" />

                    <div className="below">
                        {/* table */}
                        <Table
                            tableHeaders={[
                                "-",
                                "STORE",
                                "INVOICE NO.",
                                "TOTAL",
                                "STATUS",
                                "APPROVED BY",
                                "ENCODED BY",
                                "ACTIONS",
                            ]}
                            headerSelector={[
                                "-",
                                "store_name",
                                "invoice_no",
                                "grand_total",
                                "status",
                                "approved_by_name",
                                "encoded_by_name",
                            ]}
                            tableData={expenses}
                            ViewBtn={(row) => ViewBtn(row)}
                            ActionBtn={(row) => ActionBtn(row)}
                            showLoader={showLoader}
                        />
                    </div>
                    <div className="mb-2" />
                </div>
                <br />
                <Row>
                    <Col xs={12} lg={6}></Col>
                    <Col xs={12} lg={3}>
                        <button
                            name="action"
                            className="p-2 button-primary justify-content-center align-items-center close-btn fs-6"
                            onClick={() => navigate(-1)}
                        >
                            Close
                        </button>
                    </Col>
                    <Col xs={12} lg={3} className="mt-3 mt-lg-0">
                        <div className="PO-filters">
                        <CSVLink
                        type="button"
                        className="add-btn download-csv px-4 py-2"
                        data={expensesItems.reverse()}
                        headers={excelHeaders}
                        target="_blank"
                        filename={`${getTodayDateISO()} DailyExpenses_${branchName}`}
                    >
                        <span className="ms-3">
                                    <img
                                        width={20}
                                        height={20}
                                        src={downloadIcon}
                                    ></img>
                                </span>
                                <span className="ms-2">Download Excel</span>
                        </CSVLink>
                        </div>
                    </Col>
                </Row>
                <br />
            </div>
            <ViewModal
                show={showViewBranchModal}
                onHide={handleCloseViewBranchModal}
            >
                <div className="mt-0">
                    <div className="col-sm-12 m-0 space">
                        <span className="custom-modal-body-title-branch-details-report-modal">
                            {branchName}
                        </span>
                        <span className="custom-modal-body-title-branch-details-report-modal-right mt-0 float-r">
                            Invoice No: {expenses[0]?.invoice_no}
                        </span>
                        <div className="mt-3 container-wrapper">
                            <Row className="nc-modal-custom-row-view">
                                <Col>
                                    REMARKS
                                    <Row className="nc-modal-custom-row">
                                        <Col> {expenses[0]?.remarks || "N/A"} </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </div>
                        <div className="mt-3">
                            <Row className="nc-modal-custom-row-view">
                                <Col>
                                    ATTACHED RECEIPTS
                                    <Row className="nc-modal-custom-row">
                                        <Col> {expenses[0]?.attachment.length !==0 ? expenses[0]?.attachment : "N/A"} </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </div>
                    </div>
                </div>
            </ViewModal>
            
            
            <Modal show={showReviewModal} onHide={()=>handleCloseReviewModal()} size="lg" centered>
                <Modal.Header closeButton/>
                <Modal.Body className='pt-2'>
                    <div className='review-container p-3'>
                        <Row className="nc-modal-custom-row-view">
                            <Col xs={6}>
                                Store Name
                                <Row className="nc-modal-custom-row">
                                    <Col>
                                        {selectedRow?.store_name ||
                                            "N/A"}
                                    </Col>
                                </Row>
                            </Col>
                            <Col xs={6}>
                                Item Name
                                <Row className="nc-modal-custom-row">
                                    <Col>
                                        {selectedRowItem?.name ||
                                            "N/A"}
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                        
                        <Row className="nc-modal-custom-row-view">
                            <Col xs={6}>
                                Status
                                <Row className="nc-modal-custom-row">
                                    <Col>
                                        {selectedRowItem.status ||
                                            "N/A"}
                                    </Col>
                                </Row>
                            </Col>
                            <Col xs={6}>
                                Total
                                <Row className="nc-modal-custom-row">
                                    <Col>
                                        {selectedRowItem.total ||
                                            "N/A"}
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </div>
                    {
                        selectedRow.status === "pending" && (
                            <>
                                <div className='d-flex justify-content-end my-4'>
                                    <button
                                        className="button-warning me-2"
                                        onClick={()=>handleChangeExpenseStatus("rejected")}
                                    >
                                        Reject
                                    </button>
                                    <button
                                        className="button-primary"
                                        onClick={()=> handleChangeExpenseStatus("approved")}
                                    >
                                        Approve
                                    </button>
                                </div>
                            </>
                        )
                    }
                
                </Modal.Body>
            </Modal>
            <Footer/>
        </div>
    );
}
